"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var _validateFolderName = _interopRequireDefault(require("../utils/validateFolderName"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var AddFolderModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AddFolderModal, _Component);

  function AddFolderModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AddFolderModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AddFolderModal).call(this, props));
    _this.state = {
      isValid: false,
      folderName: '',
      validationMessage: null
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleConfirm = _this.handleConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AddFolderModal, [{
    key: "handleConfirm",
    value: function handleConfirm() {
      var onCreate = this.props.onCreate;
      var _this$state = this.state,
          isValid = _this$state.isValid,
          folderName = _this$state.folderName;

      if (isValid) {
        onCreate(folderName.trim());
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var objects = this.props.objects;
      var folderName = event.target.value;

      if (folderName) {
        var validationError = (0, _validateFolderName.default)(folderName);
        var existingName = objects.find(function (object) {
          return !(0, _FoldersAndFiles.isFile)(object) && (object.get('name') === folderName.trim() || object.get('name') === folderName);
        });
        var validationMessage = null;

        if (validationError) {
          validationMessage = validationError.message;
        } else if (existingName) {
          validationMessage = _I18n.default.text('FileManagerCore.folderNameValidation.existingFolder');
        }

        this.setState({
          isValid: !validationMessage,
          validationMessage: validationMessage,
          folderName: folderName
        });
      } else {
        this.setState({
          isValid: false,
          validationMessage: null,
          folderName: folderName
        });
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(event) {
      if (event.key === 'Enter') {
        this.handleConfirm();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var onClose = this.props.onClose;
      var _this$state2 = this.state,
          isValid = _this$state2.isValid,
          validationMessage = _this$state2.validationMessage,
          folderName = _this$state2.folderName;
      return _react.default.createElement(_UIModal.default, null, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClose
      }), _react.default.createElement(_H.default, null, _I18n.default.text('FileManagerCore.addFolderModal.createFolder'))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UIFormControl.default, {
        error: !!validationMessage,
        validationMessage: validationMessage,
        label: _I18n.default.text('FileManagerCore.addFolderModal.folderName')
      }, _react.default.createElement(_UITextInput.default, {
        "data-test-id": "add-folder-input",
        autoFocus: true,
        value: folderName,
        onKeyUp: this.handleKeyUp,
        onChange: this.handleChange
      }))), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        "data-test-id": "confirm-add-folder-button",
        use: "primary",
        disabled: !isValid,
        onClick: this.handleConfirm
      }, _I18n.default.text('FileManagerCore.actions.save')), _react.default.createElement(_UIButton.default, {
        onClick: onClose
      }, _I18n.default.text('FileManagerCore.actions.cancel'))));
    }
  }]);
  return AddFolderModal;
}(_react.Component);

exports.default = AddFolderModal;
AddFolderModal.propTypes = {
  objects: _propTypes.default.instanceOf(_immutable.default.List).isRequired,
  onClose: _propTypes.default.func.isRequired,
  onCreate: _propTypes.default.func.isRequired
};
module.exports = exports.default;